import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Loader } from "../../components";
import Form from "./setting components/Form";
import { useAxios, useComponent } from "../../hooks";

export default function AgentChannelSetting() {
  const axios = useAxios();
  const { loader } = useComponent();

  const x_sso_token = sessionStorage.getItem("ida_sso_login");
  const { accessToken, authToken } = useSelector(
    (state) => state.memberDetails
  );

  const cpassAxios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: x_sso_token ? authToken : "Bearer " + accessToken,
  });

  const [agents, setAgents] = useState([]);
  const [columns, setColumns] = useState({});
  const [agentCreated, setAgentCreated] = useState("");

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    loader.start(3);

    axios({
      url: "/get/brandAgentDetails",
      method: "POST",
      data: { brand_id: activeBrand.ID },
    }).then(async (response) => {
      if (response.status) {
        const columnMap = {};

        const agentsData = await Promise.all(
          response.data.map(async (agent) => {
            const values = [];

            const channelName = Object.keys(agent).find(
              (key) => key !== "channel_id"
            );

            if (!channelName) return null;

            const agentIDs = agent[channelName]?.map((a) => a.agent_id) || [];

            if (agentIDs.length > 0) {
              const botResponse = await cpassAxios({
                url: "/bot/agents",
                method: "POST",
                data: agentIDs,
              });

              if (botResponse.status) {
                const botData = Array.isArray(botResponse.data)
                  ? botResponse.data
                  : botResponse.data?.data || [];
                values.push(...botData);
              }
            }

            const fieldResponse = await cpassAxios({
              url: "/bot/get-agent-fields/" + agent.channel_id,
            });

            if (fieldResponse.status) {
              const fields = Array.isArray(fieldResponse.data)
                ? fieldResponse.data
                : fieldResponse.data?.data || [];

              columnMap[agent.channel_id] = fields.map((field) => ({
                label: field.label,
                name: field.name,
                options: {
                  customBodyRender: (value) =>
                    value?.length > 40
                      ? value?.substring(0, 39) + "....."
                      : value,
                },
              }));
            }

            return {
              channelID: agent.channel_id,
              channelName,
              [channelName]: values,
            };
          })
        );

        setAgents(agentsData.filter(Boolean));
        setColumns(columnMap);

        loader.apiComplete(3);
      }
    });
  }, [axios, activeBrand.ID, loader, cpassAxios]);

  return (
    <Loader>
      <Form
        setColumns={setColumns}
        columns={columns}
        agentCreated={agentCreated}
        setAgentCreated={setAgentCreated}
        agents={agents}
        setAgents={setAgents}
      />
    </Loader>
  );
}
